// @owners { team: patients }
import { RATE_SHIPMENT_DISMISSED, type rateShipmentDismissed } from '~shared/actions/rateShipment';

export type RateShipmentState = {
  lastDismissedRatingUuid: string | null | undefined;
};

const initialState: RateShipmentState = {
  lastDismissedRatingUuid: null,
};

type Actions = ReturnType<typeof rateShipmentDismissed>;

const rateShipment = (state: RateShipmentState = initialState, action: Actions): RateShipmentState => {
  switch (action.type) {
    case RATE_SHIPMENT_DISMISSED:
      return { ...state, lastDismissedRatingUuid: action.payload };

    default:
      return state;
  }
};

export default rateShipment;
